import { toEDNString } from "edn-data";
import { queryOmegaSingleResult } from "../api";
import { CreateSetupIntentResponse, CreateSubscriptionResponse, GetPaymentMethodsResponse, GetSubscriptionResponse } from "../types/payment";

export const getPaymentMethods: (config: {
  email: string;
}) => Promise<GetPaymentMethodsResponse> = async ({ email }) => {
  const ednString = toEDNString({
    map: [["email", email]],
  });
  const query = `
        (datastore Qo.Public.Api.Payment "omega/query-omega/public/api/payment")
        (Qo.Public.Api.Payment/get-payment-methods ${ednString} Response)
        (return [Response])
      `;
  const response = await queryOmegaSingleResult(query);
  return response;
};

export const createSetupIntent: (config: {
  email: string;
}) => Promise<CreateSetupIntentResponse> = async ({ email }) => {
  const ednString = toEDNString({
    map: [["email", email]],
  });
  const query = `
        (datastore Qo.Public.Api.Payment "omega/query-omega/public/api/payment")
        (Qo.Public.Api.Payment/create-setup-intent ${ednString} Response)
        (return [Response])
      `;
  const response = await queryOmegaSingleResult(query);
  return response;
};

export const createSubscription: (config: {
  email: string;
}) => Promise<CreateSubscriptionResponse> = async ({ email }) => {
  const ednString = toEDNString({
    map: [["email", email]],
  });
  const query = `
        (datastore Qo.Public.Api.Payment "omega/query-omega/public/api/payment")
        (Qo.Public.Api.Payment/create-subscription ${ednString} Response)
        (return [Response])
      `;
  const response = await queryOmegaSingleResult(query);
  return response;
};

export const getSubscription: (config: {
  email: string;
}) => Promise<GetSubscriptionResponse> = async ({ email }) => {
  const ednString = toEDNString({
    map: [["email", email]],
  });
  const query = `
        (datastore Qo.Public.Api.Payment "omega/query-omega/public/api/payment")
        (Qo.Public.Api.Payment/get-subscription ${ednString} Response)
        (return [Response])
      `;
  const response = await queryOmegaSingleResult(query);
  return response;
};

export const cancelSubscription: (config: {
  email: string;
}) => Promise<any> = async ({ email }) => {
  const ednString = toEDNString({
    map: [["email", email]],
  });
  const query = `
        (datastore Qo.Public.Api.Payment "omega/query-omega/public/api/payment")
        (Qo.Public.Api.Payment/cancel-subscription ${ednString} Response)
        (return [Response])
      `;
  const response = await queryOmegaSingleResult(query);
  return response;
};

export const setDefaultPaymentMethod: (config: {
  email: string;
  paymentMethod: string;
}) => Promise<any> = async ({ email, paymentMethod }) => {
  const ednString = toEDNString({
    map: [
      ["email", email],
      ["paymentMethod", paymentMethod],
    ],
  });
  const query = `
        (datastore Qo.Public.Api.Payment "omega/query-omega/public/api/payment")
        (Qo.Public.Api.Payment/set-default-payment-method ${ednString} Response)
        (return [Response])
      `;
  const response = await queryOmegaSingleResult(query);
  return response;
};

export const deletePaymentMethod: (config: {
  paymentMethod: string;
}) => Promise<any> = async ({ paymentMethod }) => {
  const ednString = toEDNString({
    map: [["paymentMethod", paymentMethod]],
  });
  const query = `
        (datastore Qo.Public.Api.Payment "omega/query-omega/public/api/payment")
        (Qo.Public.Api.Payment/delete-payment-method ${ednString} Response)
        (return [Response])
      `;
  const response = await queryOmegaSingleResult(query);
  return response;
};

export const activateSubscription: (config: {
  email: string;
}) => Promise<any> = async ({ email }) => {
  const ednString = toEDNString({
    map: [["email", email]],
  });
  const query = `
        (datastore Qo.Public.Api.Payment "omega/query-omega/public/api/payment")
        (Qo.Public.Api.Payment/activate-subscription ${ednString} Response)
        (return [Response])
      `;
  const response = await queryOmegaSingleResult(query);
  return response;
};
